module.exports = __webpack_public_path__ + "img/bus-3.91ef3579.png";